import { createSelector, createSlice } from '@reduxjs/toolkit';
import modifierItemsData from '../../public/modifieritems.json';

const initialState = {
  items: [],
  selectedModifier: []
};

const templateSelectedModifierItemSlice = createSlice({
  name: 'templateSelectedModifierItem',
  initialState,
  reducers: {
    loadTemplateSelectedModifierItemData(state, action) {
      state.items = modifierItemsData;
    },
    updateModifier(state, action) {
      state.selectedModifier = action.payload;
    },
  }
});

// stateからmodifierItemを取得するセレクター
const selectModifierItems = state => state.templateSelectedModifierItem;

export const selectModifierByTagName = createSelector(
  // 第一引数には入力セレクターの配列を渡す
  [selectModifierItems, (state, tagName) => tagName],
  // 第二引数には出力セレクターの関数を渡す
  (modifierItems, tagName) => {
    let element = modifierItems.items.find(item => item[tagName]);
    if (element) return element[tagName];
    else return null;
  });

export const { loadTemplateSelectedModifierItemData, updateModifier } = templateSelectedModifierItemSlice.actions;
export default templateSelectedModifierItemSlice.reducer;
